import {
    Box,
    IconButton,
    Typography,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import {Sidebar, Menu, MenuItem} from "react-pro-sidebar";
import {Link, Outlet, useNavigate} from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DataArrayIcon from "@mui/icons-material/DataArray";
import {getUser, logout} from "../../services/login/auth_service";
import {useEffect, useState} from "react";
import {AppwriteException} from "appwrite";
import FeedbackIcon from "@mui/icons-material/Feedback";
import CategoryIcon from "@mui/icons-material/Category";
import bg from "../../assets/background/BG2.jpg";
import MenuBookIcon from '@mui/icons-material/MenuBook';

const DashboardScreen = () => {
    const [showProgressIndicator, setShowProgressIndicator] = useState(false);
    const [selectedMenuItem, setSelectedMenuItem] = useState("upload-webp");
    const [showInitialLoading, setShowInitialLoading] = useState(true);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout().then(
            (response) => {
                setShowProgressIndicator(false);
                navigate("/login");
            },
            (error) => {
                if (error instanceof AppwriteException) {
                    navigate("/login");
                } else {
                }
            }
        );
    };

    useEffect(() => {
        getUser().then(
            (response) => {
                if (response instanceof AppwriteException) {
                    navigate("/login");
                } else {
                    setShowInitialLoading(false);
                    navigate("./upload-webp");
                }
            },
            (error) => {
                if (error instanceof AppwriteException) {
                }
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return showInitialLoading ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                height: "100vh",
                width: "100%",
            }}
        >
            <CircularProgress/>
        </Box>
    ) : (
        <Box width={"100%"} height={"96vh"} display={"flex"} sx={{position:'relative', display: 'flex'}}>
            {/* side menu */}
            <Sidebar
                backgroundColor="rgba(16, 1, 1, 0.5)"
                image={bg}
                width="20%"
                rootStyles={{
                    borderRadius: 0,
                    height: "96vh",
                    width: "200px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.7)",
                    position:"fixed"
                }}
            >
                {/* header */}
                <Box
                    // bgcolor={"#d0d0d0"}
                    display={"flex"}
                    justifyContent={"space-between"}
                    py={3}
                >
                    <Typography align="center" ml={10}>
                        <svg
                            width="97.4"
                            height="39.25"
                            viewBox="0 0 97.4 39.25"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g
                                id="svgGroup"
                                strokeLinecap="round"
                                fontSize="9pt"
                                stroke="#070512"
                                strokeWidth="0.25mm"
                                fill="#9990c7"
                                style={{
                                    // stroke: "#070512",
                                    stroke: "#fbfafc",
                                    strokeWidth: "0.25mm",
                                    fill: "#9990c7",
                                }}
                            >
                                <path
                                    d="M 34.1 22.05 L 34.1 25.7 L 34.65 37.45 L 27.9 38.7 L 28.5 26.55 L 27.9 1.25 L 34.75 0 L 34.1 12.95 L 34.1 18.8 A 17.963 17.963 0 0 1 35.537 17.118 A 20.085 20.085 0 0 1 35.8 16.85 A 8.686 8.686 0 0 1 36.496 16.232 Q 37.251 15.624 38.373 14.93 A 31.298 31.298 0 0 1 38.75 14.7 Q 40.75 13.5 43.025 13.5 Q 45.3 13.5 46.85 15.275 Q 48.296 16.931 48.393 19.696 A 11.51 11.51 0 0 1 48.4 20.1 L 48.1 25.7 L 48.65 37.7 L 41.9 38.95 L 42.5 26.05 Q 42.5 22.6 41.9 21.45 A 1.833 1.833 0 0 0 41.012 20.637 Q 40.29 20.3 39.1 20.3 A 6.757 6.757 0 0 0 37.213 20.589 Q 36.397 20.826 35.514 21.259 A 15.76 15.76 0 0 0 34.1 22.05 Z M 51.9 34.15 L 55.8 28.75 A 19.16 19.16 0 0 0 58.39 30.945 Q 61.345 33 64.3 33 Q 66.08 33 67.288 32.329 A 4.259 4.259 0 0 0 67.825 31.975 A 3.512 3.512 0 0 0 68.719 30.983 A 3.205 3.205 0 0 0 69.15 29.325 A 3.024 3.024 0 0 0 68.25 27.169 A 4.766 4.766 0 0 0 67.55 26.575 A 14.588 14.588 0 0 0 65.781 25.519 Q 64.813 25.025 63.675 24.6 Q 61.4 23.75 59.15 22.675 Q 56.9 21.6 55.3 19.6 A 7.272 7.272 0 0 1 53.747 15.705 A 9.432 9.432 0 0 1 53.7 14.75 A 9.733 9.733 0 0 1 56.571 7.813 A 13.586 13.586 0 0 1 57.45 6.975 Q 61.2 3.7 66.35 3.7 Q 68.7 3.7 70.9 4.2 Q 73.1 4.7 75.15 5.65 L 71.75 12.95 A 10.355 10.355 0 0 0 70.5 12.117 Q 69.403 11.489 67.925 10.925 A 17.097 17.097 0 0 0 66.225 10.37 Q 65.375 10.145 64.614 10.057 A 8.163 8.163 0 0 0 63.675 10 Q 61.85 10 60.725 10.875 A 2.768 2.768 0 0 0 59.614 12.884 A 3.507 3.507 0 0 0 59.6 13.2 A 2.621 2.621 0 0 0 60.179 14.827 Q 60.563 15.327 61.2 15.775 Q 62.8 16.9 65.075 17.75 Q 67.35 18.6 69.625 19.625 Q 71.9 20.65 73.5 22.65 A 7.272 7.272 0 0 1 75.053 26.545 A 9.432 9.432 0 0 1 75.1 27.5 A 10.714 10.714 0 0 1 72.125 34.94 A 14.572 14.572 0 0 1 71.35 35.725 Q 67.6 39.25 62.6 39.25 A 13.293 13.293 0 0 1 58.65 38.68 A 11.604 11.604 0 0 1 55.95 37.45 A 29.933 29.933 0 0 1 54.634 36.606 Q 53.388 35.756 52.657 35.026 A 6.606 6.606 0 0 1 52.35 34.7 L 51.9 34.15 Z M 0 4.2 L 10.85 4.2 A 17.146 17.146 0 0 1 13.914 4.457 Q 15.6 4.764 16.951 5.436 A 8.914 8.914 0 0 1 18.45 6.375 Q 21.25 8.55 21.25 12.2 A 11.007 11.007 0 0 1 20.804 15.435 A 7.855 7.855 0 0 1 16.45 20.35 Q 22.727 22.523 22.942 28.24 A 10.909 10.909 0 0 1 22.95 28.65 A 9.009 9.009 0 0 1 19.911 35.495 A 12.582 12.582 0 0 1 19.05 36.225 Q 15.15 39.25 9.25 39.25 Q 6.877 39.25 2.715 38.928 A 230.179 230.179 0 0 1 0 38.7 L 0.6 26.55 L 0 4.2 Z M 96.85 38.7 L 80.4 38.7 L 81 26.55 L 80.4 5.2 L 87.5 3.95 L 86.8 25.7 L 87.15 33.8 L 97.4 33 L 96.85 38.7 Z M 10.2 23.85 L 6.15 23.85 L 6.1 25.7 L 6.45 33.85 Q 8.84 34.056 10.313 34.092 A 23.957 23.957 0 0 0 10.9 34.1 A 8.559 8.559 0 0 0 12.513 33.957 Q 13.463 33.775 14.207 33.359 A 4.529 4.529 0 0 0 15.025 32.775 Q 16.429 31.513 16.497 29.141 A 8.52 8.52 0 0 0 16.5 28.9 A 6.87 6.87 0 0 0 16.354 27.433 Q 16.152 26.513 15.674 25.832 A 3.763 3.763 0 0 0 15 25.1 A 4.501 4.501 0 0 0 13.639 24.344 Q 12.275 23.85 10.2 23.85 Z M 9.05 9.25 L 6.6 9.25 L 6.3 19 L 9.55 19 A 7.555 7.555 0 0 0 11.086 18.854 Q 12.006 18.662 12.709 18.221 A 4.069 4.069 0 0 0 13.45 17.625 A 4.456 4.456 0 0 0 14.542 15.706 Q 14.8 14.816 14.8 13.7 A 4.845 4.845 0 0 0 14.418 11.701 Q 13.318 9.25 9.05 9.25 Z"
                                    vectorEffect="non-scaling-stroke"
                                />
                            </g>
                        </svg>
                    </Typography>
                    <IconButton onClick={handleLogout}>
                        <LogoutIcon htmlColor="white"/>
                    </IconButton>
                </Box>
                {/* white space separator */}
                <Box width={"100%"} height={"2px"} bgcolor={"white"}/>
                {/* side menu */}
                <Menu
                    menuItemStyles={{
                        button: {
                            // the active class will be added automatically by react router
                            // so we can use it to style the active menu item
                            [`&.ps-active`]: {
                                backgroundColor: "#ebdcfa",
                                color: "black",
                            },
                            color: "white",
                            "&:hover": {color: "black", backgroundColor: "#ddd5e6"},
                        },
                    }}
                >
                    <MenuItem
                        active={selectedMenuItem === "upload-webp"}
                        component={<Link to={"./upload-webp"}/>}
                        icon={<CloudUploadIcon/>}
                        onClick={() => setSelectedMenuItem("upload-webp")}
                    >
                        Upload Webp file(s)
                    </MenuItem>
                    <MenuItem
                        active={selectedMenuItem === "data-tables"}
                        component={<Link to={"./data-tables"}/>}
                        icon={<DataArrayIcon/>}
                        onClick={() => setSelectedMenuItem("data-tables")}
                    >
                        Data{" "}
                    </MenuItem>
                    <MenuItem
                        active={selectedMenuItem === "feedback"}
                        component={<Link to={"./feedback"}/>}
                        icon={<FeedbackIcon/>}
                        onClick={() => setSelectedMenuItem("feedback")}
                    >
                        Feedback
                    </MenuItem>
                    <MenuItem
                        active={selectedMenuItem === "categories"}
                        component={<Link to={"./categories"}/>}
                        icon={<CategoryIcon/>}
                        onClick={() => setSelectedMenuItem("categories")}
                    >
                        Categories
                    </MenuItem>
                    {/* <MenuItem
                       active={selectedMenuItem === "video-to-webp"}
                       component={<Link to={"./video-to-webp"}/>}
                       icon={<VideoFileIcon/>}
                       onClick={() => setSelectedMenuItem("video-to-webp")}
                    >
                       Video to Webp
                    </MenuItem> */}

                    <MenuItem
                        active={selectedMenuItem === "discourse-type"}
                        component={<Link to={"./discourse-type"}/>}
                        icon={<MenuBookIcon/>}
                        onClick={() => setSelectedMenuItem("discourse-type")}
                    >
                        Discourse Type
                    </MenuItem>
                    <MenuItem
                        active={selectedMenuItem === "discourse-data-table"}
                        component={<Link to={"./discourse-data-table"}/>}
                        icon={<DataArrayIcon/>}
                        onClick={() => setSelectedMenuItem("discourse-data-table")}
                    >
                        Discourse Data
                    </MenuItem>
                </Menu>
            </Sidebar>
            {/* placeholder */}
            <Box width={"78%"} paddingLeft={"20%"}>
                <Outlet />
            </Box>
            {/* loading indicator */}
            <Backdrop
                sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={showProgressIndicator}
                onClick={() => {
                }}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>
        </Box>
    );
};

export default DashboardScreen;